import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  getBffConnectionList,
  getConnectionList,
} from '../connection/endpoints.js';
import {
  AdAccountDeleteSchema,
  AdAccountSchema,
  AdAccountsResponseDataSchema,
  AdAccountVerifyResponseSchema,
  CreateAccountRequestSchema,
  CreatedAdAccountResponseSchema,
  QuerySchema,
} from '../shared/schemas/AdAccountSchema.js';

export const getList = defaultClient.query({
  url: 'omni-connector-service/ad-account/list' as const,
  method: 'GET',
  responseSchema: AdAccountsResponseDataSchema,
  querySchema: QuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const create = defaultClient.mutation({
  url: 'omni-connector-service/ad-account/bulk-create' as const,
  method: 'POST',
  responseSchema: CreatedAdAccountResponseSchema,
  requestSchema: CreateAccountRequestSchema,
  processResponse(data) {
    return data;
  },
  onSuccess: (queryClient) => {
    getBffConnectionList.invalidateAll(queryClient, {});
    getConnectionList.invalidateAll(queryClient, {});
    getList.invalidateAll(queryClient, {});
  },
});

export const bulkDelete = defaultClient.mutation({
  url: 'omni-connector-service/ad-account/bulk-delete' as const,
  method: 'DELETE',
  responseSchema: z.string(),
  querySchema: AdAccountDeleteSchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
  onSuccess: (queryClient) => {
    getBffConnectionList.invalidateAll(queryClient, {});
    getConnectionList.invalidateAll(queryClient, {});
    getList.invalidateAll(queryClient, {});
  },
});

export const update = defaultClient.mutation({
  url: 'omni-connector-service/ad-account/$adAccountId/update' as const,
  method: 'PATCH',
  responseSchema: AdAccountsResponseDataSchema,
  requestSchema: z.object({
    adAccountName: z.string(),
  }),
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getVerifyQueryOptions = defaultClient.query({
  url: 'omni-connector-service/ad-account/verify/$adAccountId' as const,
  method: 'GET',
  querySchema: z.object({
    platform: z.string(),
  }),
  responseSchema: AdAccountVerifyResponseSchema,
  processResponse(data) {
    return data?.data?.items[0].verified;
  },
});

export type CreateAccountBodyType = z.infer<typeof CreateAccountRequestSchema>;

export type DeleteAccountBodyType = z.infer<typeof AdAccountDeleteSchema>;

export type AdAccountType = z.infer<typeof AdAccountSchema>;
